/* G&G Order status JS. Reads ?id=<order> from the URL, fetches the order from
   the app (App Proxy + Admin API, ownership-checked server-side) and renders it
   in our style. */
(function () {
  'use strict';

  var POSITIVE = { PAID: 1, FULFILLED: 1 };
  var PENDING = { PENDING: 1, UNFULFILLED: 1, PARTIALLY_FULFILLED: 1, AUTHORIZED: 1, IN_PROGRESS: 1, ON_HOLD: 1, SCHEDULED: 1, PARTIALLY_PAID: 1 };

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function humanize(s) {
    return (s == null ? '' : String(s)).toLowerCase().replace(/_/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); });
  }
  function badgeClass(s) {
    s = (s == null ? '' : String(s)).toUpperCase();
    if (POSITIVE[s]) return 'is-positive';
    if (PENDING[s]) return 'is-pending';
    return '';
  }
  function money(m) {
    if (!m) return '';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: m.currencyCode }).format(parseFloat(m.amount)); }
    catch (e) { return m.amount + ' ' + (m.currencyCode || ''); }
  }
  function fmtDate(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); }
    catch (e) { return iso; }
  }

  function api(path) {
    return fetch('/apps/proxy/api/storefront' + path, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) { var e = new Error(j.error || ('HTTP ' + r.status)); e.status = r.status; throw e; }
          return j;
        });
      });
  }

  function init(root) {
    var content = root.querySelector('[data-os-content]');
    if (!content) return;
    var loadingEl = root.querySelector('[data-os-loading]');
    var bannerEl = root.querySelector('[data-os-banner]');
    var L = root.dataset;

    function fail(msg) {
      if (loadingEl) loadingEl.hidden = true;
      if (bannerEl) { bannerEl.textContent = msg; bannerEl.hidden = false; }
    }

    var id = new URLSearchParams(window.location.search).get('id');
    if (!id) { fail('No order specified.'); return; }

    function finLabel(s) {
      var u = (s == null ? '' : String(s)).toUpperCase();
      if (u === 'PAID') return L.lPaid || 'Complete';
      if (u === 'PENDING') return L.lPending || 'Pending';
      return humanize(s);
    }
    function badges(o) {
      var h = '';
      if (o.financialStatus) h += '<span class="os-badge ' + badgeClass(o.financialStatus) + '">' + esc(finLabel(o.financialStatus)) + '</span>';
      // The "Fulfilled" pill is redundant (tracking already shows shipment
      // state), so only show informative non-fulfilled states.
      var ff = (o.fulfillmentStatus == null ? '' : String(o.fulfillmentStatus)).toUpperCase();
      if (o.fulfillmentStatus && ff !== 'FULFILLED') h += '<span class="os-badge ' + badgeClass(o.fulfillmentStatus) + '">' + esc(humanize(o.fulfillmentStatus)) + '</span>';
      return h;
    }

    function moneyPos(m) { return !!(m && parseFloat(m.amount) > 0); }
    function discountValue(v) {
      if (!v) return '';
      if (v.type === 'percent') return '-' + v.percentage + '%';
      if (v.type === 'money') return '-' + money({ amount: v.amount, currencyCode: v.currencyCode });
      return '';
    }

    function itemsCard(o) {
      var rows = (o.items || []).map(function (it) {
        var thumb = it.image
          ? '<img class="os-thumb" src="' + esc(it.image) + '" alt="' + esc(it.title || '') + '" loading="lazy" width="48" height="48">'
          : '<span class="os-thumb"></span>';
        return '<div class="os-item">' + thumb +
          '<div class="os-item-info"><span class="os-item-title">' + esc(it.title || '') + '</span>' +
          '<span class="os-item-qty">' + esc(L.lQty || 'Qty') + ' ' + esc(it.quantity) + '</span></div>' +
          '<span class="os-item-total">' + esc(money(it.lineTotal)) + '</span></div>';
      }).join('');
      return '<section class="os-card"><h2 class="os-card-title">' + esc(L.lItems || 'Items') + '</h2>' + rows + '</section>';
    }

    var SAVINGS_ICON = '<svg class="os-savings-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';

    // label may contain safe markup (the discount chip); value is plain text.
    function sumRow(label, value, cls) {
      return '<div class="os-row' + (cls ? ' ' + cls : '') + '">' +
        '<span class="os-row-label">' + label + '</span>' +
        '<span class="os-row-val">' + value + '</span></div>';
    }

    function summaryCard(o) {
      var rows = '';
      if (o.subtotal) rows += sumRow(esc(L.lSubtotal || 'Subtotal'), esc(money(o.subtotal)));
      // Which discount(s) applied: code/title as a chip + the discount value.
      (o.discounts || []).forEach(function (d) {
        var val = discountValue(d.value);
        if (!d.label && !val) return;
        var label = esc(L.lDiscount || 'Discount');
        if (d.label) label += ' <span class="os-tag">' + esc(d.label) + '</span>';
        rows += sumRow(label, esc(val), 'os-row-discount');
      });
      if (o.shipping) {
        var ship = parseFloat(o.shipping.amount) > 0 ? esc(money(o.shipping)) : esc(L.lFree || 'Free');
        rows += sumRow(esc(L.lShip || 'Shipping'), ship);
      }
      if (o.tax) rows += sumRow(esc(L.lTax || 'Tax'), esc(money(o.tax)));
      rows += sumRow(esc(L.lTotal || 'Total'), esc(money(o.total)), 'os-row-total');
      // Total savings - prominent banner, only when something was discounted.
      var savings = '';
      if (moneyPos(o.totalSavings)) {
        savings = '<div class="os-savings">' + SAVINGS_ICON +
          '<span class="os-savings-label">' + esc(L.lSavings || 'Total savings') + '</span>' +
          '<span class="os-savings-val">' + esc(money(o.totalSavings)) + '</span></div>';
      }
      return '<section class="os-card os-card-summary"><h2 class="os-card-title">' + esc(L.lSummary || 'Summary') + '</h2>' +
        '<div class="os-summary">' + rows + '</div>' + savings + '</section>';
    }

    function addressCard(o) {
      var a = o.shippingAddress;
      if (!a) return '';
      var lines = [];
      var name = [a.firstName, a.lastName].filter(Boolean).join(' ');
      if (name) lines.push(name);
      if (a.address1) lines.push(a.address1);
      if (a.address2) lines.push(a.address2);
      var city = [a.city, [a.province, a.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      if (city) lines.push(city);
      if (a.country) lines.push(a.country);
      if (a.phone) lines.push(a.phone);
      if (!lines.length) return '';
      return '<section class="os-card"><h2 class="os-card-title">' + esc(L.lShipping || 'Shipping address') + '</h2>' +
        lines.map(function (l) { return '<span class="os-addr-line">' + esc(l) + '</span>'; }).join('') + '</section>';
    }

    // ----- Receipt (print / save as PDF) -----
    // Builds a clean standalone receipt in a new window and prints it, so the
    // customer can "Save as PDF". Text-only (no images) to keep it tidy and to
    // avoid print-before-load timing issues.
    function receiptHtml(o) {
      var biz = (root.getAttribute('data-receipt-business') || '').trim() ||
        (window.location && window.location.hostname) || '';
      function line(label, value, strong) {
        return '<div class="r-row' + (strong ? ' r-total' : '') + '"><span>' + esc(label) + '</span><span>' + esc(value) + '</span></div>';
      }
      var items = (o.items || []).map(function (it) {
        return '<tr><td>' + esc(it.title || '') + '</td><td class="c">' + esc(it.quantity) + '</td>' +
          '<td class="r">' + esc(money(it.lineTotal)) + '</td></tr>';
      }).join('');
      var sum = '';
      if (o.subtotal) sum += line(L.lSubtotal || 'Subtotal', money(o.subtotal));
      (o.discounts || []).forEach(function (d) {
        var v = discountValue(d.value);
        if (!d.label && !v) return;
        sum += line((L.lDiscount || 'Discount') + (d.label ? ' (' + d.label + ')' : ''), v);
      });
      if (o.shipping) sum += line(L.lShip || 'Shipping', parseFloat(o.shipping.amount) > 0 ? money(o.shipping) : (L.lFree || 'Free'));
      if (o.tax) sum += line(L.lTax || 'Tax', money(o.tax));
      sum += line(L.lTotal || 'Total', money(o.total), true);
      if (moneyPos(o.totalSavings)) sum += line(L.lSavings || 'Total savings', money(o.totalSavings));

      var a = o.shippingAddress;
      var addr = '';
      if (a) {
        var parts = [
          [a.firstName, a.lastName].filter(Boolean).join(' '),
          a.address1, a.address2,
          [a.city, [a.province, a.zip].filter(Boolean).join(' ')].filter(Boolean).join(', '),
          a.country,
        ].filter(Boolean);
        if (parts.length) addr = '<div class="r-addr"><h3>' + esc(L.lShipping || 'Shipping address') + '</h3>' +
          parts.map(function (p) { return '<div>' + esc(p) + '</div>'; }).join('') + '</div>';
      }
      return '<!doctype html><html><head><meta charset="utf-8"><title>' + esc(o.name || 'Receipt') + '</title>' +
        '<style>' +
        '*{box-sizing:border-box}body{font:14px/1.5 -apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#2C2520;margin:0;padding:32px;max-width:560px}' +
        '.r-head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #2C2520;padding-bottom:12px;margin-bottom:16px}' +
        '.r-biz{font-size:18px;font-weight:700}.r-meta{text-align:right;font-size:13px;color:#6B5E54}.r-meta b{display:block;color:#2C2520;font-size:15px}' +
        'table{width:100%;border-collapse:collapse;margin-bottom:16px}th{text-align:left;font-size:12px;text-transform:uppercase;letter-spacing:.04em;color:#6B5E54;border-bottom:1px solid #E5DDD3;padding:6px 0}' +
        'td{padding:8px 0;border-bottom:1px solid #F1ECE5;vertical-align:top}td.c{text-align:center;white-space:nowrap}td.r{text-align:right;white-space:nowrap}' +
        '.r-row{display:flex;justify-content:space-between;padding:5px 0;color:#6B5E54}.r-row span:last-child{color:#2C2520}' +
        '.r-total{border-top:1.5px solid #2C2520;margin-top:4px;padding-top:10px;font-size:16px;font-weight:700}.r-total span{color:#2C2520}' +
        '.r-addr{margin-top:20px;font-size:13px;color:#2C2520}.r-addr h3{font-size:12px;text-transform:uppercase;letter-spacing:.04em;color:#6B5E54;margin:0 0 6px}' +
        '@media print{body{padding:0}}' +
        '</style></head><body>' +
        '<div class="r-head"><div class="r-biz">' + esc(biz) + '</div>' +
          '<div class="r-meta"><b>' + esc(o.name || ('#' + o.id)) + '</b>' + esc(fmtDate(o.processedAt)) + '</div></div>' +
        '<table><thead><tr><th>' + esc(L.lItems || 'Items') + '</th><th class="c">' + esc(L.lQty || 'Qty') + '</th><th class="r">' + esc(L.lTotal || 'Total') + '</th></tr></thead><tbody>' + items + '</tbody></table>' +
        sum + addr +
        '</body></html>';
    }
    function openReceipt(o) {
      var w = window.open('', '_blank');
      if (!w) { window.alert(L.lPopup || 'Please allow pop-ups to download the receipt.'); return; }
      w.document.open();
      w.document.write(receiptHtml(o));
      w.document.close();
      w.focus();
      try { w.print(); } catch (e) {}
    }

    function fmtSize(n) {
      if (!n || n <= 0) return '';
      var u = ['B', 'KB', 'MB', 'GB'], v = n, i = 0;
      while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
      return (v >= 10 || i === 0 ? Math.round(v) : v.toFixed(1)) + ' ' + u[i];
    }
    var DL_ICON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
    var COPY_ICON = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';

    // Digital licenses for this order: license code + downloadable files.
    function downloadsCard(lics) {
      var blocks = lics.map(function (l) {
        var files = (l.files || []).map(function (f) {
          var size = f.size ? '<span class="os-dl-size">' + esc(fmtSize(f.size)) + '</span>' : '';
          return '<div class="os-dl-file">' +
            '<div class="os-dl-meta"><span class="os-dl-name">' + esc(f.filename) + '</span>' + size + '</div>' +
            '<a class="os-btn os-btn-primary os-dl-btn" href="' + esc(f.href) + '">' + DL_ICON + '<span>' + esc(L.lDownload || 'Download') + '</span></a></div>';
        }).join('');
        var code = l.licenseCode
          ? '<div class="os-dl-code"><span class="os-dl-code-label">' + esc(L.lLicenseCode || 'License code') + '</span>' +
            '<code class="os-dl-code-val">' + esc(l.licenseCode) + '</code>' +
            '<button type="button" class="os-dl-copy" data-os-copy="' + esc(l.licenseCode) + '" aria-label="' + esc(L.lCopy || 'Copy') + '">' + COPY_ICON + '</button></div>'
          : '';
        var tier = l.tierName ? '<span class="os-dl-tier">' + esc(l.tierName) + '</span>' : '';
        var terms = l.terms ? '<p class="os-dl-terms">' + esc(l.terms) + '</p>' : '';
        var title = esc(l.productTitle || '') + (l.variantTitle ? ' · ' + esc(l.variantTitle) : '');
        return '<div class="os-dl-item">' +
          '<div class="os-dl-head"><span class="os-dl-title">' + title + '</span>' + tier + '</div>' +
          code +
          (files ? '<div class="os-dl-files">' + files + '</div>' : '') +
          terms +
        '</div>';
      }).join('');
      return '<section class="os-card os-downloads"><h2 class="os-card-title">' + esc(L.lDownloads || 'Your downloads') + '</h2>' + blocks + '</section>';
    }

    function trackingCard(o) {
      var t = o.tracking || [];
      if (!t.length) return '';
      var rows = t.map(function (tr) {
        var label = (tr.number ? esc(tr.number) : esc(L.lTrack || 'Track shipment'));
        var co = tr.company ? '<span class="os-track-co">' + esc(tr.company) + '</span>' : '';
        var link = tr.url
          ? '<a class="os-btn os-btn-secondary" href="' + esc(tr.url) + '" target="_blank" rel="noopener">' + esc(L.lTrack || 'Track shipment') + '</a>'
          : '';
        return '<div class="os-track-row"><span class="os-track-num">' + label + ' ' + co + '</span>' + link + '</div>';
      }).join('');
      return '<section class="os-card"><h2 class="os-card-title">' + esc(L.lTracking || 'Tracking') + '</h2><div class="os-track">' + rows + '</div></section>';
    }

    api('/me/orders/' + encodeURIComponent(id))
      .then(function (resp) {
        var o = resp.order;
        if (!o) { fail('Order not found.'); return; }
        if (loadingEl) loadingEl.hidden = true;
        var downloadIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
        content.innerHTML =
          '<header class="os-head">' +
            '<h1 class="os-title">' + esc(o.name || ('#' + o.id)) + '</h1>' +
            '<span class="os-date">' + esc(fmtDate(o.processedAt)) + '</span>' +
            '<div class="os-badges">' + badges(o) + '</div>' +
            '<button type="button" class="os-btn os-btn-secondary os-print" data-os-print>' + downloadIcon + esc(L.lReceipt || 'Download receipt') + '</button>' +
          '</header>' +
          '<div data-os-downloads></div>' +
          '<div class="os-grid">' +
            '<div>' + itemsCard(o) + '</div>' +
            '<div>' + summaryCard(o) + addressCard(o) + trackingCard(o) + '</div>' +
          '</div>';
        content.hidden = false;
        var printBtn = content.querySelector('[data-os-print]');
        if (printBtn) printBtn.addEventListener('click', function () { openReceipt(o); });

        // Digital downloads for this order (license code + files), if any.
        api('/me/licenses?order=' + encodeURIComponent(o.id))
          .then(function (resp) {
            var lics = (resp && resp.licenses) || [];
            var host = content.querySelector('[data-os-downloads]');
            if (host && lics.length) host.innerHTML = downloadsCard(lics);
          })
          .catch(function () { /* no downloads is fine */ });

        // Copy license code.
        content.addEventListener('click', function (e) {
          var btn = e.target && e.target.closest ? e.target.closest('[data-os-copy]') : null;
          if (!btn) return;
          var code = btn.getAttribute('data-os-copy') || '';
          var done = function () { btn.classList.add('is-copied'); setTimeout(function () { btn.classList.remove('is-copied'); }, 1500); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(function () {});
          else done();
        });
      })
      .catch(function (e) {
        fail(e.status === 404 ? 'Order not found.' : ('Could not load order: ' + e.message));
      });
  }

  function boot() {
    document.querySelectorAll('.os-wrapper').forEach(function (root) {
      if (root.dataset.osInit === '1') return;
      if (root.dataset.osPreview === '1') { root.dataset.osInit = '1'; return; }
      root.dataset.osInit = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
